/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ProviderRoutes from './provider.routes';
import ProviderDirective from './provider.directive';
import ProviderTableConfig from './provider-table.config';
import ProviderDetailsController from './provider-details.controller';

export default angular.module('tektelic.provider', [])
    .config(ProviderRoutes)
    .controller('ProviderDetailsController', ProviderDetailsController)
    .directive('tkProvider', ProviderDirective)
    .factory('providerTableConfig', ProviderTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/provider/index.js